// WebCrypto
/* eslint-env browser */
export default (self.crypto || self.msCrypto);
